import Vue from 'vue';
import _ from 'lodash';
import {
    GET_B2B_GOODS_LIST_REQUEST,
    GET_B2B_GOODS_LIST_SUCCESS,
    GET_B2B_GOODS_LIST_FAILURE,
    UPDATE_B2B_GOODS_LIST_PARAMS,
    B2B_GOODS_LIST_CONFIG_RESET,
} from '../mutationTypes';

const state = {
    listLoading: false,
    list: [],
    params: {
        page: 1, // 当前页码
        pagesize: 10, // 单页加载量
        goods_name: '', // 商品名称
        start_time: '', // 确认收货开始时间
        end_time: '', // 确认收货结束时间
        is_count: 0, // 是否只返回数量（1=是，0=否）
    },
    pageCount: 1, // 总页数
    totalCount: 0, // 总条数
};
const mutations = {
    // 订单商品
    [GET_B2B_GOODS_LIST_REQUEST](state) {
        state.listLoading = true;
    },
    [GET_B2B_GOODS_LIST_SUCCESS](state, res) {
        state.listLoading = false;
        state.pageCount = res.page_count;
        state.totalCount = Number(res.count);
        const newList = _.map(res.data, ({order_id, order_sn, receive_time, goods_id, goods_name, sku_list}) => {
            const newSku = _.map(sku_list, item => ({...{sale_price: ''}, ...item}));
            return {
                id: `${goods_id}_${order_id}`,
                order_id,
                order_sn,
                receive_time,
                goods_id,
                goods_name,
                sku_list: newSku
            };
        });
        state.list = newList;
    },
    [GET_B2B_GOODS_LIST_FAILURE](state) {
        state.listLoading = false;
        state.pageCount = 1;
        state.list = [];
    },
    // 更新params参数
    [UPDATE_B2B_GOODS_LIST_PARAMS](state, obj) {
        state.params[obj.k] = obj.val;
    },
    [B2B_GOODS_LIST_CONFIG_RESET](state) {
        _.extend(state, _.cloneDeep({
            listLoading: false,
            list: [],
            params: {
                page: 1,
                pagesize: 10,
                goods_name: '', // 商品名称
                start_time: '', // 确认收货开始时间
                end_time: '' // 确认收货结束时间
            },
        }));
    }
};
export const actions = {
    // 获取订单商品list
    async getB2bGoodsList({ commit }, reqParams) {
        commit(GET_B2B_GOODS_LIST_REQUEST);
        const res = await Vue.$ajax.get('getB2bOrderGoodsList', reqParams);
        if (!res.errorType) {
            commit(GET_B2B_GOODS_LIST_SUCCESS, res);
        } else {
            commit(GET_B2B_GOODS_LIST_FAILURE);
        }
    },
    // 重置list
    resetB2bGoods({ commit }) {
        commit(B2B_GOODS_LIST_CONFIG_RESET);
    },
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/b2bOrderGoods.js